import { render, staticRenderFns } from "./PharBasedForm.vue?vue&type=template&id=c2141bbe&scoped=true&"
import script from "./PharBasedForm.vue?vue&type=script&lang=js&"
export * from "./PharBasedForm.vue?vue&type=script&lang=js&"
import style0 from "./PharBasedForm.vue?vue&type=style&index=0&id=c2141bbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2141bbe",
  null
  
)

export default component.exports